import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_TITLE = "Tournoi SQY Ping";

const ROUTE_TITLES: Record<string, string> = {
  "/": `Accueil — ${BASE_TITLE}`,
  "/boards": `Tableaux — ${BASE_TITLE}`,
  "/rules": `Règlement — ${BASE_TITLE}`,
  "/inscrits": `Liste des inscrits — ${BASE_TITLE}`,
  "/contactus": `Nous contacter — ${BASE_TITLE}`,
  "/live": `Live — ${BASE_TITLE}`,
  "/live-find": `Où jouez-vous ? — ${BASE_TITLE}`,
  "/login": `Connexion — ${BASE_TITLE}`,
  "/signup": `Inscription — ${BASE_TITLE}`,
  "/reset-password": `Réinitialiser le mot de passe — ${BASE_TITLE}`,
  "/confirm-reset-password": `Nouveau mot de passe — ${BASE_TITLE}`,
  "/register": `Inscription — ${BASE_TITLE}`,
  "/pre-registration": `Pré-inscription — ${BASE_TITLE}`,
  "/register/licence-validation": `Validation licence — ${BASE_TITLE}`,
  "/register/select": `Choisir les tableaux — ${BASE_TITLE}`,
  "/register/validation": `Validation — ${BASE_TITLE}`,
  "/register/thanks": `Merci — ${BASE_TITLE}`,
  "/admin/registrations": `Liste des inscrits — ${BASE_TITLE}`,
  "/admin/registration-list": `Liste des inscriptions — ${BASE_TITLE}`,
  "/admin/board-registrations": `Inscrits par tableaux — ${BASE_TITLE}`,
  "/admin/board-overlaps": `Croisements 2 tableaux — ${BASE_TITLE}`,
  "/admin/tournament-managment": `Gérer le tournoi — ${BASE_TITLE}`,
  "/admin/tournament-managment#remboursements": `Remboursements Stripe — ${BASE_TITLE}`,
  "/admin/boards-managment": `Capacité et ouverture — ${BASE_TITLE}`,
  "/admin/boards-definitions": `Définition des tableaux — ${BASE_TITLE}`,
  "/admin/matchs": `Gérer les matchs — ${BASE_TITLE}`,
  "/admin/checkin": `Pointage — ${BASE_TITLE}`,
  "/admin/tables-occupancy": `Occupation des tables — ${BASE_TITLE}`,
  "/admin/stats": `Statistiques — ${BASE_TITLE}`,
  "/admin/admin-rights": `Droits admin — ${BASE_TITLE}`,
  "/admin/tables-management": `Gestion des tables — ${BASE_TITLE}`,
  "/admin/docs": `Documentation — ${BASE_TITLE}`,
  "/admin/player-duplicates-audit": `Audit doublons joueurs — ${BASE_TITLE}`,
  "/admin/board-nb-participants-audit": `Cohérence compteurs tableaux — ${BASE_TITLE}`,
};

function getTitleForPath(pathname: string, hash = ""): string {
  const routeKey = hash ? `${pathname}${hash}` : pathname;
  const exact = ROUTE_TITLES[routeKey] ?? ROUTE_TITLES[pathname];
  if (exact) return exact;
  if (pathname.startsWith("/match/")) return `Match — ${BASE_TITLE}`;
  return BASE_TITLE;
}

/**
 * Hook that sets document.title based on the current route.
 * Call once in Layout (or a single route wrapper) so every navigation updates the tab title.
 */
export function usePageTitle(): void {
  const location = useLocation();

  useEffect(() => {
    document.title = getTitleForPath(location.pathname, location.hash);
  }, [location.pathname, location.hash]);
}
